
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7 14A7 7 0 117 0a7 7 0 010 14zm0-.933A6.067 6.067 0 107 .933a6.067 6.067 0 000 12.134zm0-8.692a.875.875 0 110-1.75.875.875 0 010 1.75zm-.018 7c-.347 0-.63-.318-.63-.71V6.397c0-.392.283-.71.63-.71.348 0 .63.318.63.71v4.266c0 .393-.282.711-.63.711z"}})])
          )
        }
      }
    